export enum BuildingType {
  CUC = "CUC",
  GHC = "GHC",
  TEPPER = "TEPPER",
  ALL = "ALL",
}
